import styled, { css } from 'styled-components';

// @ts-ignore
type TSLogoProps = InferProps<typeof Logo.propTypes>

const Logo = styled.i<TSLogoProps>`
  ${({ $withMask, $src }) => {
        const url = $src || '/img/logo.svg';
        return $withMask ? css`
      mask: url("${url}") no-repeat center;
      -webkit-mask: url("${url}") no-repeat center;
      background-color: currentColor;
      mask-size: contain;
      -webkit-mask-size: contain;
    ` : `
      background: url("${url}") no-repeat center;
      background-size: contain;
    `;
    }}
  display: inline-block;
  min-width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export default Logo;
